import React, { useState, useRef, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Features from "./components/Features";
import Particles from "./components/Particles";
import GradePage from "./components/GradePage";
import ChatPage from "./components/ChatPage";
import ProtectedRoute from "./components/ProtectedRoute";
import WritingPage from "./components/WritingPage";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation(); 

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  const handleLogin = () => {
    setUser({
      name: "John Doe",
      profilePic: "https://via.placeholder.com/40",
    });
  };

  const handleLogout = () => {
    setUser(null);
  };


  const showFeatures = location.pathname === "/";

  return (
    <div className={`App ${darkMode ? "dark" : ""}`}>
      {/* Global Particles Effect */}
      <ScrollToTop />
      <Particles darkMode={darkMode} />
      <Header
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        user={user}
        onLogin={handleLogin}
        onLogout={handleLogout}
      />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home darkMode={darkMode} />} />
          <Route path="/grade-demo" element={
              <ProtectedRoute>
                <GradePage />
              </ProtectedRoute>
            } />
          <Route path="/chat-demo" element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            } />
          <Route path="/write" element={<ProtectedRoute><WritingPage /></ProtectedRoute>} />
        </Routes>
        

        {showFeatures && <Features />}
      </div>
      {showFeatures && <Footer />}
    </div>
  );
}

export default App;
